var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-side-menu-content',[_c('settings-caption',[_vm._v(" サイト設定 ")]),_c('form-component'),_c('button-update')],1)}
var staticRenderFns = []

export { render, staticRenderFns }